export default {
  title: "My Profile",
  dropdown: {
    edit: "Edit",
  },
  message: "If several languages coalesce, the grammar of the resulting language is more simple and regular than that of the individual.",
  about: {
    title: "About",
    name: {
      label: "Name",
    },
    email: {
      label: "Email",
    },
    time_zone: {
      label: "Time zone",
    },
  },
}
